import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import {
  AutocompleteStyle,
  FormError,
  InputBaseStyle,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../Trade.style'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { ButtonGroupStyle, OptionContainer, SideButton } from '../../Trade.style'
import { OptionCounterparty } from '../../Trade.style'
import { CheckboxStyle, Label } from '../../../../components/styled/global.style'
import NumericFormatModal from '../../../../components/ModalApp/components/NumericFormatModal/NumericFormatModal'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'

const SpotTrade = ({
  tradeType,
  form,
  sides,
  counterParty,
  handelFormChange,
  insideDeal,
  errors,
  disabledConversionCheckBox,
  handelDateChange,
  handelFocusCurrencyPair,
  handelBlurCurrencyPair
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Counterparty *</Label>
        {Array.isArray(counterParty.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'counterparty'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.counterparty}
            options={counterParty.data.map(({ name }) => name)}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder={'Select CP'} />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Currency Pair *</Label>
        <InputBaseStyle
          value={form.currency_pair}
          name="currency_pair"
          onChange={handelFormChange}
          onFocus={handelFocusCurrencyPair}
          onBlur={handelBlurCurrencyPair}
          error={errors.currency_pair}
        />
        {errors.currency_pair !== '' && <FormError>{errors.currency_pair}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>{form.trade_type.name.includes('Client') ? 'Client' : 'Our'} Side *</Label>
        {Array.isArray(sides.data) && (
          <ButtonGroupStyle variant="outlined">
            {sides.data.map(({ name }, id) => (
              <SideButton
                name="side"
                key={id}
                value={name}
                select={String(form.side === name)}
                onClick={handelFormChange}
              >
                {name}
              </SideButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Quantity *</Label>
        <NumericFormatModal
          value={form.quantity}
          name="quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Trade Date *</Label>
        <TextFieldStyle type="datetime-local" value={form.trade_date} disabled />
      </Box>
      <Box width={'100%'}>
        <Label>Value Date *</Label>

        <TextFieldStyle
          type="date"
          variant="outlined"
          placeholder="dd-mm-yyyy"
          value={form.value_date}
          onChange={event => handelDateChange('value_date', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Price *</Label>
        <InputBaseStyle
          value={form.price}
          name="price"
          onChange={handelFormChange}
          placeholder="0.0000"
        />
      </Box>
      {tradeType === 'Market' && !insideDeal && (
        <Box style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <CheckboxStyle
            name="is_conversion"
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            onChange={handelFormChange}
            checked={form.is_conversion}
            disabled={disabledConversionCheckBox}
          />
          <Typography
            style={{ color: '#BABEC7' }}
            onClick={event => {
              if (!disabledConversionCheckBox) {
                event.target.name = 'is_conversion'
                event.target.checked = !form.is_conversion
                handelFormChange(event)
              }
            }}
          >
            Conversion Trade
          </Typography>
        </Box>
      )}
      <Box width={'100%'}>
        <Label>Note</Label>
        <TextFieldStyle
          variant="outlined"
          value={form.note}
          name="note"
          onChange={handelFormChange}
        />
      </Box>
    </>
  )
}

export default SpotTrade

SpotTrade.propTypes = {
  tradeType: PropTypes.string,
  form: PropTypes.object,
  sides: PropTypes.object,
  counterParty: PropTypes.object,
  insideDeal: PropTypes.bool,
  disabledConversionCheckBox: PropTypes.bool,
  handelFormChange: PropTypes.func,
  errors: PropTypes.object,
  handelFocusCurrencyPair: PropTypes.func,
  handelBlurCurrencyPair: PropTypes.func,
  handelDateChange: PropTypes.func
}
